import React from 'react';
import { find, propEq, pathOr } from 'ramda';
import { isPresent } from 'utils/helperMethods';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import Chat from 'sharedComponents/Chat';
import { useTranslation } from 'react-i18next';
import BuyersChatList from 'sharedComponents/BuyersChatList';

import UserPresenter from 'presenters/UserPresenter';
import ChatPresenter, { buildChatCurrentUser } from 'presenters/ChatPresenter';
import FirebaseChatPresenter from 'presenters/FirebaseChatPresenter';
import useFirebaseChat from 'reducers/hooks/firebase/useChat';
import LoanOfficerControlPage from 'sharedComponents/LoanOfficerControlPage';

import useBidRequests from 'reducers/hooks/useBidRequests';

import useStyles from './useStyles';

const DesktopMessages = props => {
  const classes = useStyles();
  const {
    isOnline,
    currentUser,
    onChatSelect,
    onMessageSend,
    onMessagesRead,
    selectedChatUid,
    chats,
    chatsInfo,
    ...rest
  } = props;

  const { t } = useTranslation();
  const { bidRequests } = useBidRequests();
  const { messages, isMessagesLoading, usersOnlineStatusList } = useFirebaseChat();
  const isChatSelected = isPresent(selectedChatUid);

  const selectedChatMessages = messages[selectedChatUid];

  const selectedChat = find(propEq('uid', selectedChatUid), chats);
  const selectedChatBuyerId = FirebaseChatPresenter.buyerId(selectedChat);
  const isOnlineSelectedChatLoanOfficer = pathOr(false, [selectedChatBuyerId, 'isOnline'], usersOnlineStatusList);
  const selectedChatInfo = chatsInfo[selectedChatUid];
  const chatParticipant = ChatPresenter.buildChatParticipantFromBuyer(
    selectedChatBuyerId,
    selectedChatInfo,
    isOnlineSelectedChatLoanOfficer,
  );
  const chatCurrentUser = buildChatCurrentUser(currentUser, isOnline);
  const bidRequest = bidRequests.find(({ buyerId }) => buyerId === selectedChatBuyerId);
  const isLoanOfficer = UserPresenter.isLoanOfficer(currentUser);

  return (
    <Box className={classes.paper}>
      <Box className={classes.loanOfficersBox}>
        <BuyersChatList
          selectedChatUid={selectedChatUid}
          bidRequests={bidRequests}
          onChatSelect={onChatSelect}
          chatsInfo={chatsInfo}
          chats={chats}
          {...rest}
        />
      </Box>
      <Box className={classes.chatBox}>
        {isChatSelected ? (
          <Chat
            isLoanOfficer={isLoanOfficer}
            chatCurrentUser={chatCurrentUser}
            isMessagesLoading={isMessagesLoading}
            chatParticipant={chatParticipant}
            messages={selectedChatMessages}
            onMessageSend={onMessageSend}
            onMessagesRead={onMessagesRead}
            chatUid={selectedChatUid}
          />
        ) : (
          <Box className={classes.chatPlaceholder}>
            <Typography variant="h2">{t('components.LoanOfficerMessages.DesktopMessages.noChatSelected')}</Typography>
          </Box>
        )}
      </Box>
      <Box className={classes.rightBar}>
        {isChatSelected ? (
          <LoanOfficerControlPage bidRequest={bidRequest} chatUid={selectedChatUid} chatParticipant={chatParticipant} />
        ) : (
          <Box className={classes.chatPlaceholder}>
            <Typography variant="h2">{t('components.LoanOfficerMessages.DesktopMessages.noChatSelected')}</Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

DesktopMessages.propTypes = {
  isOnline: PropTypes.bool.isRequired,
  onChatSelect: PropTypes.func.isRequired,
  onMessageSend: PropTypes.func.isRequired,
  onMessagesRead: PropTypes.func.isRequired,
  selectedChatUid: PropTypes.string,
  chats: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  chatsInfo: PropTypes.shape().isRequired,
};

DesktopMessages.defaultProps = {
  selectedChatUid: null,
};

export default DesktopMessages;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerMessages/components/DesktopMessages/DesktopMessages.js